import type { ChangelogEntry } from "../types";

/** Kart, sol og lys og bildeeditor i lokasjonsbanken (VIB-2939). */
export const LOKASJONER_KART_OG_SOL_2026_10: ChangelogEntry = {
  id: "2026-10-25-lokasjoner-kart-og-sol",
  date: "2026-10-25",
  title: "Lokasjonene på kart, med sol og lys",
  summary: "Lokasjonslista har fått kart med Street View, lokasjonskortet viser soltider for valgt dato, og bildene kan sorteres og flyttes.",
  sections: [
    {
      heading: "Lokasjoner",
      minRole: "user",
      items: [
        {
          title: "Kartvisning i lista",
          kind: "nytt",
          featureFlag: "feature_locations",
          body: "Velg kartet til høyre i lista. Pinner som ligger tett samles, lista ved siden av følger kartutsnittet, og du kan bytte til satellitt eller gå inn i Street View.",
        },
        {
          title: "Kart og veibeskrivelse på lokasjonskortet",
          kind: "nytt",
          featureFlag: "feature_locations",
          body: "Et lite kart med Street View i kartet, «Åpne i Google Maps» og «Veibeskrivelse», som åpner kartappen på mobilen.",
        },
        {
          title: "Sol og lys",
          kind: "nytt",
          featureFlag: "feature_locations",
          body: "Soloppgang, solnedgang, gyllen time og dagslys for datoen du velger.",
        },
        {
          title: "Sorter, velg forsidebilde og flytt bilder",
          kind: "nytt",
          featureFlag: "feature_locations",
          body: "Under «Rediger bilder» drar du bildene i ønsket rekkefølge, velger hvilket bilde som vises i lista, og flytter bilder som hører til en annen lokasjon.",
        },
      ],
    },
  ],
};
